import { FC } from 'react';
import { Modal } from 'shared/ui/modal/modal';
import Button from 'shared/ui/button/button';
import { useTranslation } from 'hooks';
import cls from './api-error-modal.module.scss';
import { Icon } from 'shared/ui/icon/icon';
import { ICONS } from 'shared/constants/images';

interface ApiErrorModalProps {
  isOpen: boolean;
  onRetry: () => void;
  onClose?: () => void;
}

export const ApiErrorModal: FC<ApiErrorModalProps> = ({
  isOpen,
  onRetry,
  onClose,
}) => {
  const { t } = useTranslation();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className={cls.errorModal}>
        <div className={cls.content}>
          <Icon pathToIcon={ICONS.error} size={24} />
          <h2 className={cls.title}>
            {t('apiErrorTitle', '_global', 'The API isn’t responding')}
          </h2>
          <p className={cls.message}>
            {t(
              'apiErrorMessage',
              '_global',
              'Unfortunately, there was a problem connecting to the API. Please try reloading the report.'
            )}
          </p>
          <div className={cls.actions}>
            <Button onClick={handleClose} className={cls.closeButton}>
              {/* // TODO: once the style of this button is defined, add it instead of css*/}
              Close
            </Button>
            <Button
              onClick={onRetry}
              theme='filled'
              tone='default'
              className={cls.retryButton}
            >
              {t('reloadReport', '_global', 'Reload report')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
